<template lang="html">
  <v-page class="client contract" :profile="profile">

    <v-topbar :profile="profile"/>
    <v-breadcrumb :steps="[
      {label:'Clientes', to: {name:'vibbrant-clients'}},
      {label: contract.client.name}
    ]"/>

    <v-container>
      <v-alert close v-if="hour_balance_absolute <= 600 && contract.status=='active'">
        <strong>Suas horas pendentes estão acabando ou acabaram!</strong><br>
        Você precisa de horas liberadas para poder registrar atividades na plataforma e ter a garantia de recebimento. Alerte o cliente sobre a necessidade de comprar créditos para que libere horas para você trabalhar.
      </v-alert>
      <v-row class="size-2">
        <v-col :xs="12" :lg="4">
          <v-card class="p-3 m-0">
            <v-avatar
              @click="showClientModal(contract.client)"
              :name="contract.client.name"
              class="mb-3"
              :image="contract.client.avatar"
            >
            </v-avatar>
            <v-list class="user-profile mt-3">
              <v-text tag='div'>Status:
                <span v-if="contract.status === 'active'">Ativo</span>
                <span v-if="contract.status === 'closed'">Finalizado</span>
              </v-text>
              <v-text tag='div'>
                Valor/hora do contrato:
                <span v-if="contract.hour_value_vibbrante != contract.expected_hour_value_vibbrante" :title="'desconto ' + calcDiscount(contract.hour_value_vibbrante, contract.expected_hour_value_vibbrante) | currency">
                  <small><s>{{contract.expected_hour_value_vibbrante | currency }}</s></small> {{contract.hour_value_vibbrante | currency }}
                </span>
                  <span v-else>
                    {{contract.hour_value_vibbrante | currency }}
                  </span>
                </span>
              </v-text>
            </v-list>
            <v-divider line/>
            <v-list class="user-profile">
              <v-text tag='div'>Email: <span>{{ contract.client.email }}</span></v-text>
              <v-text tag='div'>Celular: <span>{{ contract.client.cel_phone | cel_phone}}</span></v-text>
              <v-text tag='div'>Skype: <span>{{ contract.client.skype }}</span></v-text>
              <v-text tag='div'>Hangout: <span>{{ contract.client.hangout }}</span></v-text>
            </v-list>
            <v-divider line/>
            <v-list class="user-profile">
              <v-text tag='div'>Data de início: <span>{{ contract.expected_start_date | moment('DD/MM/YYYY') }}</span></v-text>
              <v-text tag='div'>Previsão de conclusão:
                <span>
                  {{contract.prev_closed_contract | moment('DD/MM/YYYY')}}
                  <v-helper class="text-muted" title="Previsão de conclusão" placement="top">
                    Data calculada com base no volume de horas estimadas e na disponibilidade de horas semanais do Vibbrante.
                  </v-helper>
                </span>
              </v-text>
            </v-list>
            <v-divider line/>

            <div class="d-md-flex">
              <v-link @click="goToContract(contract)">Ver contrato</v-link>
            </div>

          </v-card>
        </v-col>
        <v-col :xs="12" :lg="8">
          <v-card class="mb-3">
            <v-hours-display :contract="contract"/>
          </v-card>
          <v-card class="mb-3 p-3" v-if="contract.status === 'active' && contract.current_sprint.status === 'open' && hour_balance_absolute > 0">
            <v-row class="size-2">
              <v-col :xs="12">
                <v-input class="m-0" type="text" placeholder="Descrição da atividade" v-model="new_task.description">Novo apontamento ({{contract.current_sprint.sprint_name}})</v-input>
              </v-col>
              <v-col :xs="12" :md="4">
                <v-input class="m-0" type="select" :options="[0,1,2,3,4,5,6,7,8,9,10]" v-model="new_task.hours">Horas</v-input>
              </v-col>
              <v-col :xs="12" :md="4">
                <v-input class="m-0" type="select" :options="['00','10','20','30','40','50']" v-model="new_task.minutes">Min.</v-input>
              </v-col>
              <v-col :xs="12" :md="4" class="d-flex align-items-end">
                <v-button class="primary m-0 block" :size="2" @click="createTask()">Salvar</v-button>
              </v-col>
            </v-row>
          </v-card>
          <v-card>
            <v-text slot="title" tag="h5" class="d-flex align-items-center">
              Acompanhamento de horas
              <v-button
                class="ml-2"
                :size="2"
                @click="showExportModal"
              >
                <i class="fas fa-file-excel"></i> Exportar
              </v-button>
              <v-input class="m-0 ml-auto" type="select" v-model="current_sprint" :options="sprints_options"/>
            </v-text>

            <!-- Export Modal -->
            <div v-show="showingExportModal" class="export-modal-overlay" @click.self="closeExportModal">
              <div class="export-modal-content">
                <div class="export-modal-header">
                  <h5>Exportar</h5>
                  <button class="close-button" @click="closeExportModal">&times;</button>
                </div>
                <div class="p-3">
                  <v-row>
                    <v-col :md="6">
                      <v-input
                        type="datepicker"
                        :dateFormat="'dd/MM/yyyy'"
                        label="Data Início"
                        v-model="exportDateRange.start"
                      />
                    </v-col>
                    <v-col :md="6">
                      <v-input
                        type="datepicker"
                        :dateFormat="'dd/MM/yyyy'"
                        label="Data Fim"
                        v-model="exportDateRange.end"
                      />
                    </v-col>
                  </v-row>
                  <v-button
                    class="primary mt-3"
                    :disabled="!exportDateRange.start || !exportDateRange.end"
                    @click="exportToExcel"
                  >
                    Exportar
                  </v-button>
                </div>
              </div>
            </div>

            <v-list class="list-block">
              <v-item tag="li"  class="d-flex justify-content-between align-items-center bg-light">
                <b>
                  {{ selected_sprint.sprint_name }}: <small>de  {{ selected_sprint.opening_date | moment('DD/MM/YYYY') }} à  {{ selected_sprint.closing_date | moment('DD/MM/YYYY') }}</small>
                </b>
                <small> <b>{{selected_sprint.work_hours}} trabalhadas</b></small>
              </v-item>
              <div v-if="selected_sprint.tasks.length > 0" >
                <v-item tag="li" v-for="task in selected_sprint.tasks" class="d-md-flex justify-content-between align-items-center">
                  <span class="">
                    <div class="">
                      {{ task.description }}
                    </div>
                    <small>{{ task.task_date | moment('DD/MM/YYYY')}}</small>
                  </span>
                  <span class="">
                    <small v-if="task.status === 'review_request_by_client' " >Solicitação de revisão. Enviada em {{ task.last_comment.created_at | moment('DD/MM/YYYY') }} às {{ task.last_comment.created_at | moment('HH:mm') }} </small>
                    <v-link v-if="task.status === 'review_request_by_client' && contract.status != 'closed'" @click="showRequestHour(task.id, task.description, task.status)">Ver</v-link>

                    <small v-if="task.status === 'accepted' " >Solicitação resolvida - </small>
                    <v-link v-if="task.status === 'accepted' && contract.status != 'closed'" @click="showRequestHour(task.id, task.description, task.status)">Ver</v-link>

                    <span class="badge badge-primary badge-pill">{{task.hours}}:{{task.minutes}}h</span>
                  </span>
                </v-item>
              </div>
              <div v-else>
                <v-text>
                  Nenhum apontamento de horas até o momento
                </v-text>
              </div>
            </v-list>

          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- MODALS -->
    <v-modals
      name="client"
      :show="client_modal_show"
      :data="{user: selected_client}"
      @onHide="client_modal_show = false"
    />
    <v-modals
      name="contract-finalize"
      :show="contract_finalize_modal_show"
      :data="{}"
      @onHide="contract_finalize_modal_show = false"
    />
    <v-modals
      name="contract-new-hours"
      :show="contract_new_hours_modal_show"
      :data="{}"
      @onHide="contract_new_hours_modal_show = false"
    />
    <v-rating-modal :loading="loading" :show="showRating" :data="ratingData" />
    <v-hour-review
      name="revise-hours"
      :show="revise_new_hours_modal_show"
      profile="vibbrante"
      :data="{comments: comments, task_id: task_id, comment_from: 'vibbrante', task_description: task_description, task_status: task_status}"
      @onHide="revise_new_hours_modal_show = false"
      @createTaskComment="createTaskComment"
    />
    <v-rating-modal
      @onHide="onHideRatingModal"
      :show="showRating"
      :data="ratingData"
      :loading="loadingRating"
      :contractId="contract.id"
    />

  </v-page>
</template>

<script>
  import HoursDisplay from '../../../modules/hours-display'
  import apiVibbrante from '@/api/vibbrante'
  import apiRating from '@/api/rating'
  import HourReviewModal from '@/parts/modals/hour-review'
  import * as XLSX from 'xlsx'

  export default {
    props: {
      profile: String
    },
    components: {
      'v-hours-display': HoursDisplay,
      'v-hour-review': HourReviewModal
    },
    data() {
      return {
        loadingRating: false,
        ratingData: null,
        showRating: false,
        pago: false,
        contract_finalize_modal_show: false,
        contract_new_hours_modal_show: false,
        revise_new_hours_modal_show: false,
        client_modal_show: false,
        selected_client: {},
        new_task: {
          description: '',
          hours: 0,
          minutes: 0
        },
        comments: [],
        selected_sprint: {
          tasks: []
        },
        sprints_options: [],
        show_closed_sprint: false,
        current_sprint: '',
        task_status: '',
        showingExportModal: false,
        exportDateRange: {
          start: '',
          end: ''
        },
      }
    },
    created() {
      this.fetchData()
    },
    watch: {
      current_sprint(newSprint) {
        this.changeSelectedSprint(newSprint)
      }
    },
    mounted() {
      this.fetchRatingSprint()
    },
    methods: {
      onHideRatingModal() {
        this.showRating = false
      },
      fetchRatingSprint() {
        this.loadingRating = true
        apiRating.fetch_csat_vibbrante_close_sprint(this.$store.getters.user, this.$route.params.id)
          .then((response) => {
            if (response.data) {
              this.showRating = true
              this.ratingData = response.data
            }
          })
          .catch((error) => {
            this.$notify(error, 'error')
          })
          .finally(() => {
            this.loadingRating = false
          })
      },
      goToContract(contract) {
        this.$router.push({ name: 'vibbrant-contract', params: { id: contract.id } })
      },
      createTaskComment() {
        this.fetchData()
      },
      pagoAteAqui(n) {
        this.pago = n
      },
      showClientModal(client) {
        // this.client_modal_show = true
        this.selected_client = client
      },
      changeSelectedSprint(sprint) {
        this.current_sprint = sprint
        this.contract.contract_debits.forEach((element) => {
          if (element.sprint_name === sprint) {
            this.selected_sprint = element
          }
        })
      },
      fetchData() {
        apiVibbrante.vibbranteGetContract(this.$route.params.id).then((response) => {
          if (response.status === 200) {
            this.$store.dispatch('loadVibbranteCurrentContract', response.data)
            this.selected_sprint = response.data.current_sprint
            this.current_sprint = response.data.current_sprint.sprint_name
            this.sprints_options = []
            response.data.contract_debits.forEach((element) => {
              this.sprints_options.push(element.sprint_name)
              if (element.status !== 'open') {
                this.show_closed_sprint = true
              }
            })

            this.fetchRatingSprint()

            // Abrir a modal de review ser for o caso
            if (this.$route.params.task !== undefined) {
              this.task_id = this.$route.params.task
              apiVibbrante.vibbranteTaskComment(this.$route.params.task).then((response) => {
                if (response.status === 200) {
                  this.comments = response.data
                  this.revise_new_hours_modal_show = true
                }
              }).catch((e) => {
                this.$notify(e, 'error')
              })
            }
          }
        }).catch((e) => {
          this.$notify(e, 'error')
        })
      },
      createTask() {
        apiVibbrante.vibbranteCreateTask(this.$route.params.id, this.new_task).then((response) => {
          if (response.status === 200) {
            this.new_task = {
              description: '',
              hours: 0,
              minutes: 0
            }
            this.fetchData()
          }
        }).catch((e) => {
          this.$notify(e, 'error')
        })
      },
      showRequestHour(task_id, task_description, task_status) {
        this.task_id = task_id
        this.task_description = task_description
        this.task_status = task_status
        apiVibbrante.vibbranteTaskComment(task_id).then((response) => {
          if (response.status === 200) {
            this.comments = response.data
            this.revise_new_hours_modal_show = true
          }
        }).catch((e) => {
          this.$notify(e, 'error')
        })
      },
      calcDiscount(hour_value, expected_hour_value) {
        return (100 * (expected_hour_value - hour_value)) / expected_hour_value
      },
      showExportModal() {
        console.log('Opening modal');
        this.showingExportModal = true;
      },
      closeExportModal() {
        this.showingExportModal = false;
        this.exportDateRange = {
          start: '',
          end: ''
        };
      },
      async exportToExcel() {
        try {
          // Get all tasks for the selected date range
          const tasks = [];
          const sprintTasks = this.contract.tasks.filter(task => {
              const taskDate = new Date(task.task_date);
              const startDate = new Date(this.exportDateRange.start);
              const endDate = new Date(this.exportDateRange.end);
              return taskDate >= startDate && taskDate <= endDate;
            });
            tasks.push(...sprintTasks);

          // Format tasks for Excel
          const excelData = tasks.map(task => ({
            'Data': new Date(task.task_date).toLocaleDateString(),
            'Título': task.description,
            'Horas Trabalhadas': `${task.hours}:${task.minutes}`
          }));

          // Create workbook and worksheet
          const wb = XLSX.utils.book_new();
          const ws = XLSX.utils.json_to_sheet(excelData);

          // Add worksheet to workbook
          XLSX.utils.book_append_sheet(wb, ws, 'Horas Trabalhadas');

          // Generate filename with date range
          const fileName = `horas_trabalhadas_${this.exportDateRange.start}_${this.exportDateRange.end}.xlsx`;

          // Save file
          XLSX.writeFile(wb, fileName);
          this.closeExportModal();
        } catch (error) {
          console.error('Erro ao exportar dados:', error);
        }
      },
    },
    computed: {
      contract() {
        return this.$store.getters.vibbrante_current_contract
      },
      hour_balance_absolute() {
        return ((this.$store.getters.vibbrante_current_contract.hour_balance.split(':')[0] * 60) + (this.$store.getters.vibbrante_current_contract.hour_balance.split(':')[1] * 1))
      },
      sprintOptions() {
        const options = []
        for (let index = 0; index < this.$store.getters.vibbrante_current_contract.contract_debits.length; index++) {
          options.push(this.$store.getters.vibbrante_current_contract.contract_debits[index].sprint_name)
        }
        return options
      }
    }
  }

</script>

<style lang="scss">
  .client.contract {
    .timeline .avatar {
      display: inline-block;
      width: 50px;
    }
    .user-data {
      display: flex;
      justify-content: space-around;
      text-align: center;
    }
    .contract-filter {
      display: flex;
      .avatar {
        width: 60px;
        margin-right: size(2);
      }
    }
  }
  .export-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .export-modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 100%;
    max-width: 500px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .export-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;

    h5 {
      margin: 0;
      font-size: 1.2em;
    }
  }

  .close-button {
    background: none;
    border: none;
    font-size: 1.5em;
    cursor: pointer;
    padding: 0 5px;

    &:hover {
      color: #666;
    }
  }
</style>



// WEBPACK FOOTER //
// src/parts/pages/vibbrant/clients/client.vue